import { cx } from '@otter-ai/den-components';
import { OtterLogoIcon } from '@otter-ai/den-icons';
import { SIGNIN_HEADER_HEIGHT } from '@/constants/constant';

/**
 * @param logoCenterOnMobile - when true, centers logo on mobile instead of the default left alignment.
 */
export function LoginHeader({
  showShadow = true,
  logoCenterOnMobile = false,
}: {
  showShadow?: boolean;
  logoCenterOnMobile?: boolean;
}) {
  return (
    <header
      className={cx(
        'flex px-5 items-center relative',
        showShadow && 'sm:shadow-lg',
        logoCenterOnMobile ? 'justify-center' : 'sm:justify-center',
      )}
      style={{ height: SIGNIN_HEADER_HEIGHT }}
    >
      <a href="/" className="inline-flex">
        <OtterLogoIcon className="h-[1.8rem] w-auto text-primary" size="md" />
      </a>
    </header>
  );
}
